import React, { ReactNode, useEffect, useState } from "react";
import AddDomainButton from "../../../buttons/manage-jdl/addDomainButton";
import AddClientButton from "../../../buttons/manage-jdl/addClientButton";
import { requestStatusProps } from "../../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkSlash } from "@fortawesome/free-solid-svg-icons";

interface ModalAddHeaderProps{
    name : string
}

const AddModalContent : React.FC<ModalAddHeaderProps> = ({name})=>{

    const [inputValue, setInputValue] = useState<string>('');
    const [submitStat, setSubmitStat] = useState<requestStatusProps>({
        success : false,
        message : ''
    });
    const [button, setButton] = useState<ReactNode | null>(null);

    useEffect(()=>{
        switch(name){
            case 'Domain':
                setButton(<AddDomainButton 
                    inputName={inputValue} 
                    onSubmit={(value)=>setSubmitStat(value)} 
                    onClear={()=>setInputValue('')} />)
                break;
            case 'Client':
                setButton(<AddClientButton 
                    inputName={inputValue} 
                    onSubmit={(value)=>setSubmitStat(value)} 
                    onClear={()=>setInputValue('')} />)
                break;
        }
    }, [inputValue, name])

    if(button === null){
        return(
            <div className="text-gray-500 text-center">
                <h1 className="text-center text-4xl">
                    <FontAwesomeIcon icon={faLinkSlash} />
                </h1>
                <p className="text-center text-xl">
                    Failed to load components.
                </p>
                <small>Please try again.</small>
            </div>
        );
    }

    return (
        <div>
            <div>
                Add New {name}
            </div>
            <div>
                <div className={submitStat.success ? "text-green-600" :"text-red-500"}>
                    {submitStat.message}
                </div>
                <form>
                    <div className="input-container flex flex-col">
                        <label htmlFor="">{name} Name: </label>
                        <input type="text" value={inputValue} onChange={(e)=>setInputValue(e.target.value)} className="text-box" />
                    </div>
                    {button}
                </form>
            </div>
        </div>
    );
}

export default AddModalContent;